export enum PortletVersion {
    _1 = '1.0',
    _2 = '2.0',
    _3 = '3.0'
}
